<template>
  <div class="parceiroes">
    <h1 class="titulo-card fs-4">Parceiros de rede neutra</h1>
    <div class="form-group card-principal">
      <div class="d-flex justify-content-between">
        <div class="input-group mb-3">
          <button v-on:click="handleAdicionar()" class="btn btn-success">
            <font-awesome-icon :icon="['fas', 'plus']" fixed-width class="me-1"/>Adicionar
          </button>
        </div>

        <div class="input-group mb-3">
          <input
              v-on:keyup.enter="handlePesquisa()"
              type="text"
              class="form-control"
              placeholder="Pesquisar"
              aria-label="Pesquisar"
              aria-describedby="button-addon2">
          <button v-on:click="handlePesquisa()" class="btn btn-outline-secondary" type="button" id="button-addon2">
            <font-awesome-icon :icon="['fas', 'search']" fixed-width class="me-1"/>
          </button>
        </div>
      </div>
      <div class="d-flex">
        <table class="table table-sm-pc table-striped table-hover">
          <thead>
            <tr>
              <th>Descrição curta</th>
              <th>Visualização discovery</th>
              <th width="110"></th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="parceiro in listaParceiros" :key="parceiro.id" v-bind:class="cssParceiro(parceiro)">
                <td scope="row">{{parceiro.descricaoCurta}}</td>
                <td>{{traduzVisualizaçãoDiscovery(parceiro.visualizacaoDiscovery)}}</td>
                <td class="text-end">
                  <button type="button" v-on:click="handleEditaParceiro(parceiro)" class="btn btn-primary btn-sm me-1">
                    <font-awesome-icon :icon="['fas', 'edit']" fixed-width/>
                  </button>
                  <button type="button" v-on:click="handleRemoveParceiro(parceiro)" class="btn btn-danger btn-sm">
                    <font-awesome-icon :icon="['fas', 'times']" fixed-width/>
                  </button>
                </td>

              </tr>
            </tbody>
        </table>
      </div>
      <Paginador v-model="paginador" @change-paginacao="onChangePaginacao"/>

      <!-- modal-edita-parceiro -->
      <!-- Button trigger modal -->
      <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-edita-parceiro" id="btn-modal-edita-parceiro-abre">
        Launch
      </button>

      <!-- Modal -->
      <div class="modal fade" id="modal-edita-parceiro" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 v-if="(!modalParceiro.parceiro)" class="modal-title">
                <font-awesome-icon :icon="['fas', 'plus']" fixed-width/>
                Cadastrar novo parceiro
              </h5>
              <h5 v-if="(modalParceiro.parceiro)" class="modal-title">
                <font-awesome-icon :icon="['fas', 'pen']" fixed-width/>
                Editando parceiro
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12 col-md-4">
                  <div class="col-12 mb-2">
                    <label>Cadastro (clientes)</label>
                    <div class="input-group">
                      <input type="text" disabled v-bind:value="textoClienteSelecionado" class="form-control" placeholder="Selecione o cliente" aria-describedby="button-addon2">
                      <button v-on:click="abreModalPesquisaClientes()" class="btn btn-outline-primary" type="button" id="button-addon2">
                        <font-awesome-icon :icon="['fas', 'search']" fixed-width/>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <label class="required">Descrição curta</label>
                  <input type="text" v-model="modalParceiro.form.descricaoCurta" class="form-control">
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <label class="required">Visualização discovery</label>
                  <select v-model="modalParceiro.form.visualizacaoDiscovery" class="form-control">
                    <option :value="undefined" disabled>Selecione</option>
                    <option :value="'vdTodos'">Todas ONUs</option>
                    <option :value="'vdPreCadastro'">Apenas pré-cadastradas</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" id="btn-modal-edita-parceiro-fecha">Fechar</button>
              <button type="button"
                  v-if="(!modalParceiro.parceiro)"
                  v-on:click="handlemodalParceiroCadastrar()"
                  v-bind:disabled="!podeSalvarParceiro()"
                  class="btn btn-success">
                Cadastrar
              </button>
              <button type="button"
                  v-if="(!!modalParceiro.parceiro)"
                  v-on:click="handlemodalParceiroSalvar()"
                  v-bind:disabled="!podeSalvarParceiro()"
                  class="btn btn-success">
                Salvar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal-edita-parceiro -->
  </div>
</template>

<script>
import Paginador from '@/components/Paginador.vue'
import api from '@/modules/api'
import dialogo from '@/modules/dialogo'
import loading from '@/modules/loading'
import clone from '@/modules/clone'
import model from '@/model'
import pesquisaCliente from '@/modules/pesquisa-cliente'

export default {
  name: 'ParceirosRedeNeutra',
  components: {
    Paginador,
  },
  data() {
    return {
      /** @type {model.paginador} */
      paginador: clone(model.paginador),
      listaParceiros: [],
      modalParceiro: {
        parceiro: undefined,
        clienteSelecionado: undefined,
        form: {
          clienteId: undefined,
          visualizacaoDiscovery: '',
          descricaoCurta: undefined,
        },
      },
    }
  },
  methods: {
    handlePesquisa() {
      loading(true);

      api.get(`/rede-neutra/parceiros?${this.paginador.requestParams}`).then(res => {
        loading(false);
        this.listaParceiros = res.data.itens;
        this.paginador.pagina = res.data.paginacao.pagina;
        this.paginador.totalItens = res.data.paginacao.total;
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    onChangePaginacao() {
      this.handlePesquisa();
    },

    handleAdicionar() {
      this.resetModalParceiro();
      this.abreModalCadastroParceiro();
    },

    async handleEditaParceiro(parceiro) {
      this.resetModalParceiro();

      this.modalParceiro.parceiro = parceiro;
      this.modalParceiro.form.clienteId = parceiro.clienteId;
      this.modalParceiro.form.visualizacaoDiscovery = parceiro.visualizacaoDiscovery;
      this.modalParceiro.form.descricaoCurta = parceiro.descricaoCurta;

      this.abreModalCadastroParceiro();
    },

    handleRemoveParceiro(parceiro) {
      dialogo.confirmacao(`Confirma remover o usuário <b>${parceiro.nome}</b>?`).then(() => {
        loading(true);

        api.delete(`/rede-neutra/parceiros/${parceiro.id}`).then(() => {
          loading(false);

          this.handlePesquisa();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },

    cssParceiro() {
      // if (!parceiro.ativo) {
      //   return ['text-muted'];
      // }

      return ['text-info'];
    },

    traduzVisualizaçãoDiscovery(tipo) {
      switch (tipo) {
        case 'vdTodos':
          return 'Todas ONUs';

        case 'vdPreCadastro':
          return 'Pré-cadastradas';
      }

      return '';
    },

    //MODAL EDIT
    abreModalCadastroParceiro() {
      document.getElementById('btn-modal-edita-parceiro-abre').click();
    },

    resetModalParceiro() {
      this.modalParceiro.parceiro = undefined;
      this.modalParceiro.form.clienteId = undefined;
      this.modalParceiro.form.visualizacaoDiscovery = undefined;
      this.modalParceiro.form.descricaoCurta = '';
    },

    podeSalvarParceiro() {
      switch (true) {
        case (!this.modalParceiro.form.clienteId):
        case (!this.modalParceiro.form.visualizacaoDiscovery):
        case (this.modalParceiro.form.descricaoCurta.length < 3):
          return false;

        default:
          return true;
      }
    },

    handlemodalParceiroCadastrar() {
      const form = this.modalParceiro.form;

      const sendData = {
        clienteId: form.clienteId,
        visualizacaoDiscovery: form.visualizacaoDiscovery,
        descricaoCurta: form.descricaoCurta,
      };

      loading(true);

      api.post('/rede-neutra/parceiros', sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-parceiro-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    handlemodalParceiroSalvar() {
      const id = this.modalParceiro.parceiro.id;
      const form = this.modalParceiro.form;

      const sendData = {
        clienteId: form.clienteId,
        visualizacaoDiscovery: form.visualizacaoDiscovery,
        descricaoCurta: form.descricaoCurta,
      };


      loading(true);
      api.put(`/rede-neutra/parceiros/${id}`, sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-parceiro-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    abreModalPesquisaClientes() {
      pesquisaCliente().then(res => {
        this.modalParceiro.clienteSelecionado = clone(res);
        this.modalParceiro.form.clienteId = res.id;
      });
    },
    //MODAL EDIT
  },

  computed: {
    textoClienteSelecionado() {
      if (!this.modalParceiro.clienteSelecionado) {
        return '';
      }

      return this.modalParceiro.clienteSelecionado.razao_social;
    }
  },

  created() {
    this.handlePesquisa();
  }
}
</script>
